import React from 'react'
import { connect } from 'react-redux'
import OrderInformation from './OrderInformation'
import '@/assets/styles/components/order/order-cancel.scss';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import OrderConfirmStatus from '../OrderConfirm/OrderConfirmStatus';
import { ORDER_MODE } from '@/constants/app';
import classnames from 'classnames';
import { formatFunctions } from "../../helpers/functions";
import { dataType } from "@/constants/data-type";

class OrderCancel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowResult: false,
      orderResult: {},
      orderData: {},
      isLoading: true
    }
  }

  render() {
    const { language, isMobile } = this.props;
    const { isShowResult, orderResult, orderData, isLoading } = this.state;
    const grossAmount = orderData.grossAmt
      ? `${orderData.currencyID} ${formatFunctions.dataFormat(orderData.grossAmt, dataType.CURRENCY)}`
      : `${orderData.currencyID} ${formatFunctions.dataFormat(orderData.price * orderData.qty, dataType.CURRENCY)}`
    return (
      <React.Fragment>
        {isShowResult
          ? <OrderConfirmStatus
            mode={ORDER_MODE.CANCEL}
            orderData={orderData}
            orderResult={orderResult}
            onClose={() => this.props.onClose()}
            isCancel='Y'/>
          : !isLoading &&
          <React.Fragment>
            <div className="order-cancel-container" style={{ width: isMobile && '90vw' }}>
              <header>{language.order_confirm_message.format(language.order_cancel_title)}</header>
              <OrderInformation order={orderData} mode={ORDER_MODE.CANCEL} />
              {isMobile && <div className="gross-amount-mobile">
                <span>{language.common_gross_amount}</span>
                <span>{grossAmount}</span>
              </div>}
              <div className={classnames("action", isMobile && 'action-mobile')}>
                <button type="button" className='cancel' onClick={() => {
                  this.props.onClose()
                }}>{language.common_cancel}</button>
                <button type="button" className='confirm'
                  onClick={this.handleConfirm}>{language.common_confirm}</button>
              </div>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  handleConfirm = () => {
    const { language, order, currentTradingAccount } = this.props;
    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
      [PARAMS.ORDER_ID]: order.orderID
    }
    this.props.cancelOrder(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        // if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        const orderResult = {
          ...this.state.orderData,
          ...res.result,
          isSuccess: res.result.isSuccess,
          orderID: this.state.orderData.orderID,
          inputTime: this.state.orderData.inputTime
        }
        if (this.props.isMobile) {
          this.props.onClose(orderResult);
        } else {
          this.setState({ orderResult, isShowResult: true })
        }
        // }
      }
    })
  }

  getData = () => {
    const { currentTradingAccount, language, order } = this.props
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getOrderDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : order;
            this.setState({ orderData: orderData });
          }
        }
        this.setState({ isLoading: false })
      })
    }
  }

  componentDidMount() {
    this.getData();
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c)),
    cancelOrder: (p, res) => dispatch(orderActions.cancelOrderAction(p, res))
  })
)(OrderCancel)
